var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEngineSpeed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 295.238 295.238",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M257.143,157.143h-14.286v-28.571H220.49l-28.571-19.048h-30.014V80.952H200v-9.524H85.714v9.524h38.095v28.571H93.476 l-33.333,28.571h-26.81v28.571H9.524V123.81H0v119.048h9.524v-38.095h23.81v38.095h27.305l33.333,19.048h53.648v-9.524H96.505 l-29.838-17.048v-90.286l30.333-26h92.033l25.252,16.833v16.5h9.524v-14.286h9.524v114.286h-9.524v9.524h19.048v-23.81h14.286 v9.524h38.095V142.857h-38.095V157.143z M33.334,195.238H9.524V176.19h23.81V195.238z M57.143,233.333H42.857v-85.714h14.286 V233.333z M152.381,109.523h-19.048V80.952h19.048V109.523z M257.143,228.571h-14.286v-61.905h14.286V228.571z M266.667,152.381 h19.048v85.714h-19.048V152.381z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.448,176.19h-35.576l23.81-33.333h-45.533L106.576,200h29.962l-12.833,44.933L192.448,176.19z M121.99,190.476 l19.048-38.095h21.133l-23.81,33.333h31.09l-26.495,26.495l6.214-21.733H121.99z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.095,
    y: 28.571,
    width: 28.571,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    y: 28.571,
    width: 28.571,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.571,
    y: 38.095,
    width: 9.524,
    height: 28.571
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.571,
    y: 0,
    width: 9.524,
    height: 28.571
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.191,71.429 276.191,52.381 266.667,52.381 266.667,71.429 276.19,71.429 276.19,80.952 266.667,80.952  266.667,71.429 247.619,71.429 247.619,80.953 266.667,80.953 266.667,100 276.191,100 276.191,80.953 295.238,80.953  295.238,71.429  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.476,
    y: 252.381,
    width: 23.81,
    height: 9.524
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.953,252.381 190.476,252.381 190.476,228.571 180.952,228.571 180.952,252.381 157.143,252.381  157.143,261.905 180.952,261.905 180.952,285.715 190.476,285.715 190.476,261.905 180.953,261.905  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.714,266.667 276.19,266.667 276.19,276.19 266.667,276.19 266.667,285.714 276.19,285.714 276.19,295.238  285.714,295.238 285.714,285.714 276.191,285.714 276.191,276.191 285.714,276.191 285.714,285.714 295.238,285.714  295.238,276.19 285.714,276.19  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngineSpeed);
export default __webpack_public_path__ + "static/media/engineSpeed.78ac6151b600c7d55679c527b8a82b2c.svg";
export { ForwardRef as ReactComponent };